class Currency {
    hasCurrency() {
        return _.get(window.slurp, `auth.franchise.currency.symbol`, '');
    }
}

const CurrencyInstance = new Currency();

export default CurrencyInstance;
